import { render, staticRenderFns } from "./payresult.vue?vue&type=template&id=36b88964&scoped=true"
import script from "./payresult.vue?vue&type=script&lang=js"
export * from "./payresult.vue?vue&type=script&lang=js"
import style0 from "./payresult.vue?vue&type=style&index=0&id=36b88964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b88964",
  null
  
)

export default component.exports